import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import {
  agentBehaviorSettingsDefaultValue,
  AgentBehaviorSettingsForm,
  agentBehaviorSettingsFormSchema,
} from '@/modules/gpt-chats/components/agents-configuration/components/config-card-section/utils';
import { Agent } from '@/modules/gpt-chats/types/agent.service.type';

export const useAgentForm = (agent?: Agent) => {
  return useForm({
    mode: 'onChange',
    resetOptions: {
      keepDirtyValues: true,
    },
    resolver: zodResolver(agentBehaviorSettingsFormSchema),
    values: agent
      ? ({
          ...agent,
          llm_config: {
            ...agent.llm_config,
            is_blocks_provider: agent.llm_config?.is_blocks_provider ?? true,
            model_id: agent.llm_config?.model_id ?? '',
            model_type: agent.llm_config?.model_type ?? 'chat',
            base_prompt: agent.llm_config?.base_prompt ?? '',
          },
          guardrail: {
            ...agent.guardrail,
            custom_rules:
              agent.guardrail.custom_rules?.map((r) => ({
                name: r.name,
                pattern: r.pattern,
                severity: r.severity.toLowerCase() as 'low' | 'medium' | 'high',
                auto_block: r.auto_block,
                enable_pre: r.enable_pre,
                enable_post: r.enable_post,
                message: r.message ?? '',
              })) ?? [],
          },
          memory_config: {
            ...agent.memory_config,
            enable_questions_suggestions: agent.widget?.enable_questions_suggestions ?? false,
          },
          enable_knowledge_base:
            agent.enable_knowledge_base !== undefined
              ? !!agent.enable_knowledge_base
              : !!(agent.rag_config?.embedding_model || agent.rag_config?.chunking_strategy),

          kb_ids: (agent as any).kb_ids ?? [],
          folder_ids: agent.folder_ids ?? [],

          enable_tools: agent.enable_tools !== undefined ? !!agent.enable_tools : false,

          enable_memory:
            agent.enable_memory !== undefined
              ? !!agent.enable_memory
              : !!(
                  agent.memory_config?.last_n_conversations || agent.memory_config?.enable_summary
                ),

          enable_human_handoff:
            agent.enable_human_handoff !== undefined ? !!agent.enable_human_handoff : false,
        } as unknown as AgentBehaviorSettingsForm)
      : agentBehaviorSettingsDefaultValue,
  });
};
